@if (redirectsToUrl) {
  <!--case we want to go to external website on a new tab-->
  <a data-cy="admin-doc-card-folder-view"
     [href]="url" target="_blank" rel="noreferrer"
     (mouseenter)="displayExtLinkIcon = true"
     (mouseleave)="displayExtLinkIcon = false"
  >
    <ng-container *ngTemplateOutlet="cardComponentBody"></ng-container>
  </a>
} @else {
  <!--case we want to stay in explain app-->
    <!--middle click is for the mouse wheel click-->
  <a data-cy="admin-doc-card-folder-view"
     [routerLink]="getRouterLink()"
     (contextmenu)="onClickCard()"
     (click)="onClickCard()"
     (middleclick)="onClickCard()"
     [state]="{context: text}">
    <ng-container *ngTemplateOutlet="cardComponentBody"></ng-container>
  </a>
}

<ng-template #cardComponentBody>
  <div id="card-{{docId}}" [ngClass]="{'preview': isPreview}" class="document-card" [style]="cardStyles">
    <div class="document-info">
      @if (!isPreview && source) {
        <div class="document-source">
          <div>{{ ('document.issuer-kind.' + (source ?? 'undetected')) | translate }}</div>
          <i class="ph-bold ph-caret-right color-basic-600"></i>
          <i class="ph-bold ph-file-text color-basic-600"></i>
          <div class="fw-600" [style.font-style]="(displayedPublicationType === DisplayedPublicationType.NON_DETECTED) ? 'italic' : 'normal'"
          >{{ displayedPublicationType }}</div>
        </div>
      }
      <div class="document-publication-date">
        <i class="ph-bold ph-calendar-check color-basic-600"></i>
        @if (publicationDate) {
          <div>{{publicationDate | date:'dd MMMM yyyy':'':'fr' }}</div>
        } @else {
          <div>{{ 'content.date_not_detected' | translate }}</div>
        }
      </div>
      @if (isPreview) {
        <div class="document-website">
          <i class="ph-bold ph-globe"></i>
          <div>{{ website }}</div>
        </div>
      }
    </div>

    <!--line containing folder icon, title and occurrence badge-->
    <div class="document-head">
      @if (bookmarkPaths && bookmarkPaths.length > 0) {
        <mat-icon class="icon-24" svgIcon="saved-folder-icon-green"></mat-icon>
      }
      <div class="document-title-container">
        <div class="document-title"
             data-cy="admin-doc-search-card-board-title"
             [innerHTML]="title">
        </div>
        @if (!isPreview && redirectsToUrl && displayExtLinkIcon) {
          <i class="ph-bold ph-arrow-square-out external-link-icon"></i>
        }
      </div>

      @if (showOccurrences && nbOccurrences) {
        <div class="document-occurrences">
          {{ nbOccurrences }} {{
            nbOccurrences === 1
              ? ('content.occurrence' | translate)
              : ('content.occurrences' | translate)
          }}
        </div>
      }
    </div>

    @if (!isPreview && territories && territories.length > 0) {
      <div class="document-territories" id="territory-section-{{docId}}">
        <i class="ph-bold ph-map-pin"></i>
        @if (territories && territories.length) {
          <div class="document-territories-list" id="territory-list-{{docId}}">
            @for (territory of territories; track territory.uid; let i = $index) {
              @if (territory.uid.startsWith(TerritoryKind.REGION)) {
                <span>{{ "content.region" | translate }}</span>
              }
              <span>{{territory['name']}}</span>
              @if (territory.uid.startsWith(TerritoryKind.DEPARTMENT)) {
                <span>({{territory.code}})</span>
              }
              @if (i !== territories.length - 1) {
                <span>|</span>
              }
            }
          </div>
          @if (displayReadMore) {
            <div id="read-more-{{docId}}"
                 class="document-territories-more"
                 (click)="onReadMoreClick($event)"
                 [ngbTooltip]="territoryTooltip"
                 tooltipClass="simple-tooltip"
                 placement="bottom-right">
              <i class="ph-bold ph-plus"></i>
              <div>{{"content.see-more"| translate}}</div>
            </div>
          }
        } @else {
          <div class="document-no-territories">
            {{'content.non-detected-territory' | translate}}
          </div>
        }
      </div>
    }
    @if (isPreview) {
      <div class="document-publication-type">
        @if (displayedPublicationType !== DisplayedPublicationType.NON_DETECTED) {
          <i class="ph-fill ph-read-cv-logo"></i>
        } @else {
          <i class="ph-fill ph-read-cv-logo color-basic-600"></i>
        }
        <div
          [ngClass]="(displayedPublicationType === DisplayedPublicationType.NON_DETECTED) ? 'color-basic-600' : ''"
          [style.font-style]="(displayedPublicationType === DisplayedPublicationType.NON_DETECTED) ? 'italic' : 'normal'"
        >{{ displayedPublicationType }}
        </div>
      </div>
    }

    @if (text) {
      <div class="document-text" data-cy="admin-doc-search-card-board-text" [innerHTML]="text"></div>
    } @else {
      <div class="document-text fst-italic color-basic-600"
           data-cy="admin-doc-search-card-board-text">{{ 'content.extract-not-detected' | translate }}
      </div>
    }
  </div>
</ng-template>

<ng-template #territoryTooltip class="territory-tooltip">
      <span *ngFor="let territory of territories; let i = index">
            <span class="territory-name fw-bold color-white">{{territory['name']}}</span>
            <span *ngIf="territories && i < territories.length - 1"
                  class="separator color-basic-600 fw-light"> | </span>
      </span>
</ng-template>
